import { render } from "./PocProductFilter.vue?vue&type=template&id=686a84a4&scoped=true"
import script from "./PocProductFilter.vue?vue&type=script&lang=js"
export * from "./PocProductFilter.vue?vue&type=script&lang=js"

import "./PocProductFilter.vue?vue&type=style&index=0&id=686a84a4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686a84a4"]])

export default __exports__